module.exports = __webpack_public_path__ + "static/media/d3d-gen-iros26.af6d9b8d.png";